<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import Modal from '../$components/modal.container.svelte'

    import TipsComponent from './component.tips.svelte'
    import TipComponent from './component.tip.svelte'
    import TipCreate from './component.create.svelte'
    import TipUpdate from './component.update.svelte'

    if(!isPermission($adminStore, 'SettingsView.Tips.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Tips" subtitle="Consejos y tips para la plataforma" />
    <TipsComponent />
</View>

<Modal id="tip_create_modal" title="Crear Tip">
    <TipCreate />
</Modal>

<Modal id="tip_update_modal" title="Actualizar Tip">
    <TipUpdate />
</Modal>

<Modal id="tip_modal" title="Información Tip">
    <TipComponent />
</Modal>
